"use strict";

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _get = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _getPrototypeOf = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LifeDelay = void 0;

var ValueWithRandom_1 = require("../../ValueWithRandom");

var LifeDelay = /*#__PURE__*/function (_ValueWithRandom_1$Va) {
  _inherits(LifeDelay, _ValueWithRandom_1$Va);

  var _super = _createSuper(LifeDelay);

  function LifeDelay() {
    var _this;

    _classCallCheck(this, LifeDelay);

    _this = _super.call(this);
    _this.sync = false;
    return _this;
  }

  _createClass(LifeDelay, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      _get(_getPrototypeOf(LifeDelay.prototype), "load", this).call(this, data);

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);

  return LifeDelay;
}(ValueWithRandom_1.ValueWithRandom);

exports.LifeDelay = LifeDelay;